export default __webpack_public_path__ + "static/media/bmw-box.185d90ec.png";